export default class ProjectDescriptionMetricsIdTranslations {
    constructor(translation) {
        const { id, title, unit } = translation;
        this.id = id;
        this.title = title !== null && title !== void 0 ? title : '';
        this.unit = unit !== null && unit !== void 0 ? unit : '';
    }
}
